import { render, staticRenderFns } from "./SelectRelation.vue?vue&type=template&id=41ffd16b&scoped=true&"
import script from "./SelectRelation.vue?vue&type=script&lang=js&"
export * from "./SelectRelation.vue?vue&type=script&lang=js&"
import style0 from "./SelectRelation.vue?vue&type=style&index=0&id=41ffd16b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ffd16b",
  null
  
)

export default component.exports